<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Editar grupos</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex order-xs2 order-md2 xs12 md6>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      :value="student.firstName"
                      label="Nombre(s)"
                      readonly
                      solo-inverted
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      solo-inverted
                      :value="student.lastName"
                      label="Apellidos"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <label>
                      <a
                        @click="flags.extraLevels = !flags.extraLevels"
                      >{{ (flags.extraLevels) ? 'Niveles' : 'Extracurricular' }}</a>
                    </label>
                  </v-flex>
                  <v-slide-x-transition mode="out-in">
                    <v-flex :key="1" v-if="!flags.extraLevels" xs12 ma-0 pa-0>
                      <v-flex xs12>
                        <v-select
                          :error-messages="levelErrors"
                          label="Nivel"
                          :items="levels"
                          solo-inverted
                          height="50"
                          return-object
                          item-text="typeLevel"
                          @change="filterGGsByLevel"
                          :dense="$vuetify.breakpoint.xsOnly"
                          v-model="$v.userForm.level.$model"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          :error-messages="ggErrors"
                          label="Grado y grupo"
                          :items="ggs"
                          solo-inverted
                          height="50"
                          return-object
                          :item-text="text"
                          v-model="$v.userForm.gg.$model"
                          :dense="$vuetify.breakpoint.xsOnly"
                          required
                        ></v-select>
                      </v-flex>
                    </v-flex>
                    <v-flex :key="2" v-else xs12 ma-0 pa-0>
                      <v-flex xs12>
                        <v-select
                          multiple
                          label="Nivel"
                          :items="extraLevels"
                          solo-inverted
                          height="50"
                          return-object
                          item-text="typeLevel"
                          @change="filterExtraGGsByLevel"
                          :dense="$vuetify.breakpoint.xsOnly"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          multiple
                          label="Actividad y grupo"
                          :items="extraGGs"
                          solo-inverted
                          height="50"
                          return-object
                          :item-text="text"
                          :dense="$vuetify.breakpoint.xsOnly"
                          required
                        ></v-select>
                      </v-flex>
                    </v-flex>
                  </v-slide-x-transition>
                  <v-flex xs12>
                    <v-text-field
                      solo-inverted
                      readonly
                      :value="student.personId"
                      label="Matrícula"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex order-xs1 order-md2 xs8 offset-xs2 md6 offset-md0>
                <v-layout align-center justify-center row fill-height wrap>
                  <v-flex xs7 text-xs-center>
                    <v-avatar
                      size="170"
                      :class="(student.imageStorage && student.imageStorage.miniObjUrl) ? 'elevation-2' : ''"
                    >
                      <img
                        v-if="student.imageStorage && student.imageStorage.miniObjUrl"
                        :src="student.imageStorage.miniObjUrl"
                      />
                      <img v-else :src="require('@/assets/panel/home/SKLB-Alumnos.png')" />
                    </v-avatar>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">Cancelar</v-btn>
          <v-btn :disabled="working.wUpdate" color="primary darken-1" flat>Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  props: ["value", "student"],
  validations: {
    userForm: {
      level: { required },
      gg: { required }
    }
  },
  watch: {
    value() {
      this.getLevels();
    }
  },
  data: () => ({
    levels: [],
    ggs: [],
    selectedLevel: {},
    extraLevels: [],
    extraGGs: [],
    userForm: {
      level: {},
      gg: {},
      extras: []
    },
    working: {
      wUpdate: false
    },
    flags: {
      extraLevels: false
    }
  }),
  methods: {
    text: item => item.grade + "" + item.group,
    close() {
      this.$emit("input", false);
    },
    filterGGsByLevel(val) {
      this.levels.filter(item => {
        if (item.id == val.id) {
          this.ggs = item.ggs;
          this.$forceUpdate();
        }
      });
    },
    filterExtraGGsByLevel(val) {
      this.extraGGs = [];
      this.extraLevels.filter(item => {
        if (item.id == val.id) {
          this.extraGGs = this.extraGGs.concat(item.ggs);
          this.$forceUpdate();
        }
      });
    },
    setInfoToShowOnUpdate() {
      if (this.value) {
        if (this.student != null) {
          this.userForm.level = this.student.level;
          for (var lvl in this.levels) {
            if (this.student.level.id == this.levels[lvl].id) {
              this.ggs = this.levels[lvl].ggs;
              this.$forceUpdate();
              break;
            }
          }
          this.userForm.gg = this.student.gg;
        }
      }
    },
    getLevels() {
      this.working.wUpdate = true;
      this.$store
        .dispatch("tutor/getLevelsParentTool")
        .then(response => {
          this.levels = response.data.entity.levels;
          this.working.wUpdate = false;
          this.setInfoToShowOnUpdate();
        })
        .catch(error => {
          this.working.wUpdate = false;
          console.log(error);
          this.toast.failed = true;
        });
    }
  },
  computed: {
    levelErrors() {
      const errors = [];
      if (!this.$v.userForm.level.$dirty) return errors;
      !this.$v.userForm.level.required && errors.push("Nivel obligatorio");
      return errors;
    },
    ggErrors() {
      const errors = [];
      if (!this.$v.userForm.gg.$dirty) return errors;
      !this.$v.userForm.gg.required &&
        errors.push("Grado y grupo obligatorios");
      return errors;
    }
  }
};
</script>

<style scoped>
/deep/ .v-input .v-input__slot {
  border-radius: 33px !important;
}

/deep/ .v-menu__content {
  border-radius: 23px;
}
</style>